import { RiTextSnippet } from "react-icons/ri";

import { useGetWhoami } from "@/api/whoami/get-whoami";
import { routePaths } from "@/config/route-paths";

import { SideNavItemLink } from "./SideNavItemLink";

/**
 * プレースホルダ管理への導線。ホストだけに出す。
 *
 * API がホスト限定のため、admin / member に見せても 403 になるだけ。
 */
export const SideNavItemPlaceholderManagement = () => {
  const { isHost } = useGetWhoami();

  if (!isHost) {
    return null;
  }

  return (
    <SideNavItemLink
      label="プレースホルダ管理"
      icon={<RiTextSnippet size={20} className="text-[#F2F5FC]" />}
      href={routePaths.admin.placeholders.getHref()}
    />
  );
};
